import type { Coupon, CouponStatus } from '../fixtures';
import type { TagCategory } from '../../../../../components/ui/Tag';

/** 状态点档位：进行中=活跃（品牌蓝）、未开启=提醒（橙）、已结束=中性（灰）。与电子推荐卡列表同一套配色。 */
export type CouponStatusTone = 'active' | 'warning' | 'muted';

/** 券种是业务分类，不借用成功／警告等功能语义色。 */
export function couponTypeTagCategory(type: Coupon['type']): TagCategory {
  if (type === '折扣券') return 'violet';
  if (type === '课时券') return 'cyan';
  return 'blue';
}

/** 券来源是业务来源标识，列表统一使用短标签。 */
export function couponSourceLabel(source: Coupon['source']): string {
  return source === '优惠券' ? '优惠券' : source;
}

/** 规则类别同样属于业务分类，不使用成功等状态色。 */
export function ruleKindTagCategory(kind: 'single' | 'group'): TagCategory {
  return kind === 'group' ? 'violet' : 'blue';
}

export function couponStatusTone(status: CouponStatus): CouponStatusTone {
  if (status === '进行中') return 'active';
  if (status === '未开启') return 'warning';
  return 'muted';
}

/** 仅用于 Tag 渲染；Tag 没有品牌色档位，进行中沿用 success。状态点请走 couponStatusTone。 */
export function couponStatusTagType(status: CouponStatus): 'success' | 'warning' | 'neutral' {
  const tone = couponStatusTone(status);
  return tone === 'active' ? 'success' : tone === 'warning' ? 'warning' : 'neutral';
}
